var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full bg-gray-400 h-px my-3"})}
var staticRenderFns = []

export { render, staticRenderFns }